import PropTypes from 'prop-types';
import { attr, fk, Model } from 'redux-orm';

class PatientCaregiver extends Model {
  static modelName = 'PatientCaregiver';

  static fields = {
    id: attr(),
    isPrimary: attr(),
    firstName: attr(),
    lastName: attr(),
    email: attr(),
    phone: attr(),
    phoneType: attr(),
    dateOfBirth: attr(),
    sex: attr(),
    relationship: attr(),
    livesWithPatient: attr(),
    medicareStatus: attr(),
    mbi: attr(),
    roleYears: attr(),
    roleMonths: attr(),
    preferredLanguage: attr(),
    techComfortLevel: attr(),
    mindspanCaregiverId: attr(),
    mindspanCaregiverCognitoStatus: attr(),
    deletedAt: attr(),
    updatedAt: attr(),
    createdAt: attr(),
    updatedBy: fk('Client', 'caregiverChanger'),
    createdBy: fk('Client', 'caregiverCreator'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'caregivers',
    }),
  };

  getName() {
    return `${this.firstName} ${this.lastName}`;
  }

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      isPrimary: PropTypes.bool,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      phoneType: PropTypes.string,
      dateOfBirth: PropTypes.string,
      sex: PropTypes.string,
      relationship: PropTypes.string,
      livesWithPatient: PropTypes.bool,
      medicareStatus: PropTypes.string,
      mbi: PropTypes.string,
      roleYears: PropTypes.number,
      roleMonths: PropTypes.number,
      preferredLanguage: PropTypes.string,
      techComfortLevel: PropTypes.string,
      mindspanCaregiverId: PropTypes.string,
      mindspanCaregiverCognitoStatus: PropTypes.string,
      deletedAt: PropTypes.string,
      updatedAt: PropTypes.string,
      createdAt: PropTypes.string,
      updatedBy: PropTypes.number,
      createdBy: PropTypes.number,
      patientId: PropTypes.number,
    }),
    patientId: PropTypes.number,
  };
}

export default PatientCaregiver;
